import { StringKeyDictionary } from "../commonInterfaces";
import { Entity } from "../core/components/commonApp";
import {
    BaseColumn,
    EditableGrid,
    EditableGridProps,
    field,
    InGridButtonClickParams,
    InGridToolBarButton,
    Schema,
    ValidationResult,
    ValidationResultType
} from "../core/components/editableGrid/editableGrid";
import { EditableGridHelper } from "../core/components/editableGrid/editableGridHelper";
import { ValidationBuilder } from "../core/components/editableGrid/validationBuilder";
import { ToolBarInGridButtonType } from "../core/components/toolBar";
import { Helper } from "../core/util/helper";
import { OpenWeeklyReportCopyDialog } from "./dialogs/weeklyReportCopyDialog";
import { EntityWeeklyReportEntry } from "./weeklyReport";
import React from "react";
export class WeeklyReportInGrid extends React.Component<WeeklyReportGridProps, {
}>{
    translations: StringKeyDictionary<string> = null;
    editableGridRef: EditableGrid;

    constructor(props: any) {
        super(props);
        this.state = {
        };
        this.translations = this.props.translations;
    }

    componentDidMount() {
    }

    private flag: boolean = false;
    onGridDataChanged = async (action: string, fieldName: string, dataItems: any) => {
        if (action == "itemchange" && !this.flag) {
            this.handleItemChanged(fieldName, dataItems);
            this.flag = false;
        }
        else if (action == "add") {
        }
        else if (action == "remove") {

        }
        this.props.onChange();
    }

    private handleItemChanged(fieldName: string, dataItems) {
        let changedDataItem = dataItems[0];
        this.flag = true;
        let dataItem: EntityWeeklyReportEntry = changedDataItem;
        switch (fieldName) {
            case "Datum":
                changedDataItem.set("Tag", kendo.toString(kendo.parseDate(changedDataItem.Datum), "ddd"));
                dataItem.DatumUtc = Helper.dates.getISODateString(changedDataItem.Datum);
                break;
            case "IsProduktiveTaetigkeit":
                changedDataItem.set("Kunde_Taetigkeit", null);
                changedDataItem.set("TaetigkeitId", null);
                break;
            case "Zeittyp":
            case "Zvon":
            case "Zbis":
            case "Utcoffset":
            case "UtcoffsetZbis":
                this.calculateZarbeit(dataItem);

                changedDataItem.set("Zfahrt", dataItem.Zfahrt);
                changedDataItem.set("Zarbeit", dataItem.Zarbeit);
                changedDataItem.set("Zpause", dataItem.Zpause);
                changedDataItem.set("Zgesamt", dataItem.Zgesamt);
                changedDataItem.set("TotalTime", this.getTotalTime(changedDataItem));
                break;
        }
        changedDataItem.set("Changed", true);
    }

    private calculateZarbeit = (dataItem: EntityWeeklyReportEntry) => {
        dataItem.Zfahrt = 0;
        dataItem.Zarbeit = 0;
        dataItem.Zpause = 0;

        const zvon = dataItem.Zvon + dataItem.Utcoffset;
        const zbis = dataItem.Zbis + dataItem.Utcoffset - dataItem.UtcoffsetZBis;

        if (dataItem.Zeittyp != null) {
            switch (dataItem.Zeittyp) {
                case 1:
                case 3:
                case 9:
                    dataItem.Zfahrt = zbis - zvon;
                    break;
                case 2:
                case 4:
                case 6:
                case 7:
                case 8:
                    dataItem.Zarbeit = zbis - zvon;
                    break;
                case 5:
                    dataItem.Zpause = zbis - zvon;
                    break;
            }
        }
        dataItem.Zgesamt = dataItem.Zfahrt + dataItem.Zarbeit;
    }

    handleButtonClick = (p: InGridButtonClickParams) => {
        switch (p.id) {
            case "new":
                let entity = this.createNewEntity();
                p.actions.add(this.calcNewValues(p.dataSource, entity));
                break;
            case "edit":
                p.actions.editSelected();
                break;
            case "delete":
                p.actions.deleteSelected(true);
                break;
            case "newDay":
                const newItem: EntityWeeklyReportEntry = this.createNewEntity();
                this.calcNewValuesDay(p.dataSource, newItem);
                p.actions.add(newItem);
                break;
            case "copy":
                this.copySelectedEntries(p.selectedItems, p.dataSource);
                break;
        }
    }

    private copySelectedEntries = async (dataItems: any[], dataSource: kendo.data.DataSource) => {
        let entries: any = dataSource.data();

        let days = await OpenWeeklyReportCopyDialog(this.props.entity, entries);
        for (let day of days) {
            for (let selectedItem of dataItems) {
                let newEntity = JSON.parse(JSON.stringify(selectedItem));
                newEntity.IsNew = true;
                newEntity.Pos = this.getNewPos(entries, dataSource);
                newEntity.DatumUtc = Helper.dates.getISODateString(day);
                newEntity.Datum = day;
                newEntity.Tag = kendo.toString(day, "ddd");
                dataSource.add(newEntity);
            }
        }
    }

    private getNewPos = (entries: EntityWeeklyReportEntry[], dataSource: kendo.data.DataSource): number => {
        let destroyedData = dataSource["destroyed"]();

        let newPos = 1;

        if (entries.length >= 1) {
            let entriesForPos = entries.filter(x => Helper.hasValue(x.Pos) && x.Projnr == "WB");
            if (entriesForPos.length >= 1)
                newPos = entriesForPos.reduce((prev, current) => (prev.Pos > current.Pos) ? prev : current).Pos + 1;
        }
        if (destroyedData.length >= 1) {
            let destroyedMaxPos = destroyedData.filter(x => Helper.hasValue(x.Pos)).reduce((prev, current) => (prev.Pos > current.Pos) ? prev : current).Pos + 1;
            if (destroyedMaxPos > newPos)
                newPos = destroyedMaxPos;
        }

        return newPos;
    }

    private calcNewValues(dataSource: kendo.data.DataSource, newEntry: EntityWeeklyReportEntry) {
        let entries = (dataSource.data() as any) as EntityWeeklyReportEntry[];

        let newPos = this.getNewPos(entries, dataSource);
        let newDate = this.getNewDate(entries);

        this.setDate(newEntry, newDate);

        newEntry.Pos = newPos;
        if (entries.length >= 1) {
            let maxZbis = entries.filter(x => Helper.hasValue(x.Datum) && x.Datum.getDate() == newDate.getDate()).reduce((prev, current) => (prev.Zbis > current.Zbis) ? prev : current);
            if (Helper.hasValue(maxZbis) && maxZbis.Zbis > newEntry.Zvon) {
                let newZvon = maxZbis.Zbis;
                let newZbis = maxZbis.Zbis + 60;
                if (newZvon > 1440 || newZbis > 1440) {
                    if (newDate.getDate() != new Date(this.props.entity.Bis).getDate()) {
                        newDate.setDate(newDate.getDate() + 1);
                        this.setDate(newEntry, newDate);
                    } else {
                        newEntry.Zvon = 1440;
                        newEntry.Zbis = 1440;
                    }
                } else {
                    newEntry.Zvon = newZvon;
                    newEntry.Zbis = newZbis;
                }
            }
        }
        newEntry.TotalTime = this.getTotalTime(newEntry);

        return newEntry;
    }

    private calcNewValuesDay(dataSource: kendo.data.DataSource, newEntry: EntityWeeklyReportEntry) {
        let entries = (dataSource.data() as any) as EntityWeeklyReportEntry[];

        let newPos = this.getNewPos(entries, dataSource);
        let newDate = this.getNewDate(entries, true);

        newEntry.DatumUtc = Helper.dates.getISODateString(newDate);
        newEntry.Datum = newDate;
        newEntry.Tag = kendo.toString(newDate, "ddd");
        newEntry.Pos = newPos;
        newEntry.TotalTime = this.getTotalTime(newEntry);
    }

    createNewEntity = (): EntityWeeklyReportEntry => {
        let config = this.props.entity.Config;
        const defUtcOffset = config.DefaultUserUtcOffset;

        let newEntry: EntityWeeklyReportEntry = {
            IsNew: true,
            Zvon: config.DefaultArbeitsbeginn,
            Zbis: config.DefaultArbeitsende,
            Utcoffset: defUtcOffset,
            UtcoffsetZBis: defUtcOffset,
            Belegnr: this.props.entity.Belegnr,
            Projnr: "WB",
            Ressnr: this.props.entity.Ressnr,
            IsProduktiveTaetigkeit: true,
            Isguid: "{" + kendo.guid() + "}",
            Changed: true,
            RecordRight: {
                CanRead: this.props.entity.RecordRight.CanRead,
                CanWrite: this.props.entity.RecordRight.CanWrite
            },
            IndividualFields: {},
            IsWatchable: false,
            IsWatched: false,
            Zeittyp: null
        };

        return newEntry;
    }

    private getTotalTime = (dataItem) => {
        return this.props.entity.SaveTimeShift ? (dataItem.Zbis - dataItem.UtcoffsetZBis) - (dataItem.Zvon - dataItem.Utcoffset) : (dataItem.Zbis - dataItem.Zvon);
    }

    public getEntries(): any {
        let currentItems = this.editableGridRef.getData();
        return currentItems;
    }

    onRequestItemValidation = (columns: BaseColumn[], dataItem: EntityWeeklyReportEntry): ValidationResult => {
        let validationBuilder = new ValidationBuilder();

        if (dataItem.Projnr === "WB") {
            validationBuilder.checkReqiredFields(columns, dataItem);
        }

        return validationBuilder.build();
    }

    groupHeaderColumnTemplateTotalTime = (group: any) => {
        let value = group.items.filter(x => x.Zeittyp != 5).reduce(function (prev, curr) { return prev + curr.TotalTime; }, 0);
        let timeStringValue = Helper.dates.fromMinutesSinceMidnight(value);
        return timeStringValue;
    }

    private onlySameDayChecked = (dataItems: any[]) => {
        return !dataItems
            || dataItems.length == 1
            || dataItems
                .map((x) => {
                    return x.Datum.getDate();
                })
                .filter(function (value, index, self) {
                    return index == self.indexOf(value);
                }).length == 1;
    }

    private canCreateNewDay = (dataSource: kendo.data.DataSource) => {
        let entries = this.props.data;
        if (dataSource)
            entries = (dataSource.data() as any);
        let newDate = this.getNewDate(entries, true);
        return newDate.getDate() <= new Date(this.props.entity.Bis).getDate();
    }

    private getNewDate = (entries, nextDay: boolean = false) => {
        let newDate = kendo.parseDate(this.props.entity.Von);
        if (entries.filter(x => Helper.hasValue(x.Datum)).length > 0) {
            newDate = new Date(entries.filter(x => Helper.hasValue(x.Datum)).reduce((prev, current) => (prev.Datum > current.Datum) ? prev : current).Datum);
            if (nextDay)
                newDate.setDate(newDate.getDate() + 1);
        }

        return newDate;
    }

    private setDate = (entry: EntityWeeklyReportEntry, date: Date) => {
        entry.DatumUtc = Helper.dates.getISODateString(date);
        entry.Datum = date;
        entry.Tag = kendo.toString(date, "ddd");
    }

    private onDataBound = (e) => {
        e.sender.items().map((idx, row) => {
            let dataItem = e.sender.dataItem(row);
            var backgroundColors = this.props.gridOptions["rowBackgroundColors"];
            if (!backgroundColors)
                return;
            if (dataItem.Projnr === "WB" && backgroundColors["wrTimes"]) {
                $(row).css("background-color", backgroundColors["wrTimes"]);
            } else if (backgroundColors["srTimes"]) {
                $(row).css("background-color", backgroundColors["srTimes"]);
            }
        });
    }

    render() {
        let editable = this.props.entity.RecordRight.CanWrite;

        const buttons: Array<InGridToolBarButton> = [];
        buttons.push({ type: ToolBarInGridButtonType.NEW, id: "new" });
        buttons.push({
            type: ToolBarInGridButtonType.NEW,
            id: "newDay",
            caption: Helper.getTranslation("WebSMS.WeeklyReport.NewDay"),
            enabled: (p) => editable && this.canCreateNewDay(p.dataSource)
        });
        buttons.push({ type: ToolBarInGridButtonType.EDIT, id: "edit", enabled: (p) => this.props.entity.RecordRight.CanWrite && p.hasSingleSelection });
        buttons.push({ type: ToolBarInGridButtonType.DELETE, id: "delete" });
        buttons.push({
            type: ToolBarInGridButtonType.CUSTOM,
            id: "copy",
            caption: Helper.getTranslation("Standard.Kopieren"),
            enabled: (p) => editable && p.hasSelection && this.onlySameDayChecked(p.selectedItems),
            iconClass: "k-i-copy",
            useContextMenu: true
        });

        let schema = new Schema();
        schema.Id = "Pos";
        schema.fields["Pos"] = new field("number");
        return <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
            <EditableGrid id="wrTimes"
                editable={editable}
                data={this.props.data}
                gridOptions={this.props.gridOptions}
                schema={schema}
                resolveAdditionalData={() => { }}
                onDataChanged={this.onGridDataChanged}
                ref={(ref) => this.editableGridRef = ref}
                onRequestItemValidation={this.onRequestItemValidation}
                rowReadOnly={(dataItem) => dataItem.Projnr !== "WB" || dataItem.Readonly == 1}
                buttons={buttons}
                onButtonClick={this.handleButtonClick}
                onDataBound={this.onDataBound}
                {...this.props}
                {...{ groupHeaderColumnTemplateTotalTime: this.groupHeaderColumnTemplateTotalTime }}
            />
        </div>
    }
}

export interface WeeklyReportGridProps extends EditableGridProps{
    entity: EntityWeeklyReport;
    data: EntityWeeklyReportEntry[];
    gridOptions: any;
    dataSources: any;
    translations: StringKeyDictionary<string>;
    onChange?: () => void;
}

export interface EntityWeeklyReport extends Entity {
    RecordRight: {
        CanRead: boolean;
        CanWrite: boolean;
        CanTechnicalRelease: boolean;
        CanCommercialRelease: boolean;
        CanDelete: boolean;
    };
    Belegnr: number;
    Ressnr: string;
    Name: string;
    Monat_Jahr: string;
    Kalenderwoche: number;
    IsReleased: boolean;
    IsReleasedCommercial: boolean;
    Kenner1: boolean;
    Signedby: string;
    Email: string;
    Internalremarks: string;
    Entries: Array<EntityWeeklyReportEntry>;
    Config: EntityWeeklyReportConfig;
    isConverted: boolean;
    SaveTimeShift: boolean;
    Von?: string;
    Bis?: string;
}

interface EntityWeeklyReportConfig {
    DefaultArbeitsbeginn: number;
    DefaultArbeitsende: number;
    DefaultArbeitszeit: number;
    DefaultPause: number;
    DefaultFahrtzeit: number;
    DefaultUserUtcOffset: number;
}